import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';
import { UtilService } from './util';


@Injectable({
  providedIn: 'root'
})
export class CEPService {

  url = 'https://viacep.com.br/ws/';

  constructor(
    private httpClient: HttpClient,
    private utilService: UtilService
  ) {}

  getObjectByValue(value: string): Observable<any> {
    return this.httpClient.get(`${this.url}/${value}/json/`, this.utilService.filtrosHttpOptions());
  }

}
